//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('consignmentBatchConsignments', {
//        templateUrl: 'views/components/views/consignmentBatchConsignments/consignmentBatchConsignments.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'consignmentBatchConsignmentsService', function ($stateParams, consignmentBatchConsignmentsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let consignmentBatchKeyno = $stateParams.consignmentbatch_keyno;

//            vm.model = {
//                itemsListConsignments: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALL
            
//            async function loadConsignments() {
//                vm.model.itemsListConsignments = await consignmentBatchConsignmentsService.listConsignments({ consignmentbatch_keyno: consignmentBatchKeyno });
//            }

//            // #endregion LOAD PROCEDURE CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadConsignments();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
